import { Controller } from '@hotwired/stimulus';

// TODO: This controller is intentionally left empty.
// Functionality is in the legacy controllers folder until it can be
// refactored to the new component structure.
export default class extends Controller {

  //eslint-disable-next-line no-empty-function
  connect() {}
}
